enum UserRole {
    User,
    Admin
}

export default UserRole;